import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeaturesBaseComponent } from './components/features-base.component';
import { AlertDialogComponent } from './components/alert/alertdialog.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { AuthorizationService } from './services/authorization.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgPassOtpModule } from 'ng-pass-otp';
import { MatMenuModule } from '@angular/material/menu';
import { BackButtonDirective } from './back-button.directive';
import { NavigationService } from './services/navigation.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateConfigService } from './services/translate-config.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxPopper } from 'angular-popper';
import { PhoneFormatComponent } from './components/phone-format/phone-format.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SweetAlert2LoaderService, SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TextMaskModule } from 'angular2-text-mask';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { HideIfUnauthorizedDirective } from './components/disable-directive/hide-if-unauthorized.directive';
import { DisableIfUnauthorizedDirective } from './components/disable-directive/disable-if-unauthorized.directive';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { AngularLottieModule } from 'angular-lottie';
import { ToastrService } from 'ngx-toastr';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InvoiceDialogComponent } from './components/invoice-dialog/invoice-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { SortOrderPipe } from '../framework/pipes/sort-order/sort-order.pipe';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import { CustomTooltip } from './components/tool-tip/tool-tip.component';
import { ViewCommentComponent } from '../features/retailers/manage-retailer/comments/view-comment.component';

export function initializeApp(authzService: AuthorizationService) {
  const promise = authzService.initializePermissions().then((config) => {
   
   
  });
  return () => promise;
}

@NgModule({
  declarations: [FeaturesBaseComponent, AlertDialogComponent, DialogComponent, BackButtonDirective, PhoneFormatComponent, HideIfUnauthorizedDirective, DisableIfUnauthorizedDirective, ConfirmationDialogComponent, InvoiceDialogComponent, SortOrderPipe, CustomTooltip, ViewCommentComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatDialogModule,
    MatTabsModule,
    MatCheckboxModule,
    MatMenuModule,
    NgPassOtpModule,
    RouterModule,
    MatTooltipModule,
    MatAutocompleteModule,
    NgxPopper,
    TranslateModule,
    TextMaskModule,
    FlexLayoutModule,
    MatTableModule,
    AngularLottieModule,
    PdfViewerModule,
    MatChipsModule,
    MatBadgeModule,
    Nl2BrPipeModule
  ],
  exports: [
    SortOrderPipe,
    CommonModule,
    MatToolbarModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatDialogModule,
    MatTabsModule,
    MatCheckboxModule,
    MatMenuModule,
    NgPassOtpModule,
    MatTooltipModule,
    RouterModule,
    TranslateModule,
    MatAutocompleteModule,
    NgxPopper,
    FeaturesBaseComponent, AlertDialogComponent, DialogComponent, PhoneFormatComponent, ConfirmationDialogComponent,
    BackButtonDirective,
    TextMaskModule,
    FlexLayoutModule,
    MatTableModule,
    AngularLottieModule,
    HideIfUnauthorizedDirective, DisableIfUnauthorizedDirective, PdfViewerModule, MatChipsModule, MatBadgeModule, Nl2BrPipeModule, CustomTooltip, ViewCommentComponent
  ],
  providers: [
     NavigationService, TranslateConfigService, ToastrService,
    AuthorizationService,SortOrderPipe,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AuthorizationService], multi: true },
  ],
})
export class FeaturesCommonModule { }
